import React, { Component } from "react";
import Config from './Config';
import Collapsible from './Collapsible';
import {Table, Modal, Button} from 'react-bootstrap';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { Textbox } from 'react-inputs-validation';
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreatableSelect from 'react-select/lib/Creatable';
import {Glyphicon} from 'react-bootstrap';
 
class Item extends Component {

    constructor(props){
        super(props);
        this.state = {
            isLoading: true,
            data: [],
            originalData: [],
            message: '',
            config: Config.item,
            show: false,
            item : {},
            options: [],
            selectedOption: {}
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.handleDeleteOfItemType = this.handleDeleteOfItemType.bind(this);
    }

    handleClose() {
        this.setState({ show: false });
    }
    
    handleShow() {
        this.setState({ show: true });
    }

    handleSave(){
        if(this.state.selectedOption === null || this.state.item.name === undefined || this.state.item.hsncode === undefined || this.state.item.cgst_tax === undefined || this.state.item.sgst_tax === undefined ){
            toast.error("Please fill all the fields and continue", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: false
            });
            return false;
        }
        if(this.state.selectedOption.__isNew__){
            let item_type = {}
            item_type.deleted = 0;
            item_type.name = this.state.selectedOption.value;
            let body = { "item_type" : [ item_type ] }; 
            fetch(this.state.config.url_save_item_type, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                // mode: "cors",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    // "Content-Type": "application/x-www-form-urlencoded",
                    // Accept: "application/json"
                },
                body: JSON.stringify(body), // body data type must match "Content-Type" header
            })
            .then(response => response.json())
            .then((data) => {
                if (data.success) {
                    this.handleSaveItem();
                }
            })
            .catch((error) => {
                toast.error("Could not save new Item Type. Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: false
                });
            });
        } else {
            this.handleSaveItem();
        }
    }

    handleSaveItem(){
        let body = {}
        let item = this.state.item;
        item.deleted = 0;
        item.type = this.state.selectedOption && this.state.selectedOption.value;
        item.id = (new Date()).getTime();
        body = { "item" : [ item ] };
        fetch(this.state.config.url_save_item, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: "cors",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                // "Content-Type": "application/x-www-form-urlencoded",
                // Accept: "application/json"
            },
            body: JSON.stringify(body), // body data type must match "Content-Type" header
        })
        .then(response => response.json())
        .then((data) => {
            if(data.success){
                this.setState({
                    item : {},
                    hasError: false,
                    selectedOption: this.state.options[0]
                });
                this.handleClose();
                toast.success("Saved "+ this.state.config.type, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 5000
                });
                this.fetchData();
            } else {
                toast.error("Could not save " + this.state.config.type + ". Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: false
                });
            }
        })
        .catch((error) => {
            console.log(error);
            toast.error("Could not save " + this.state.config.type + ". Please try again.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: false
            });
        });
    }

    componentWillMount(){
        localStorage.getItem(this.state.config.type) && this.setState({
            data: JSON.parse(localStorage.getItem(this.state.config.type)),
            originalData: JSON.parse(localStorage.getItem(this.state.config.type)),
            options: JSON.parse(localStorage.getItem(this.state.options)),
            selectedOption: (localStorage.getItem(this.state.options))[0],
            isLoading: false
        });
    }

    componentDidMount(){

        const date = localStorage.getItem(this.state.config.type + "Date");
        const dataDate = date && new Date(parseInt(date, 10));
        const now = new Date();

        const dataAge = Math.round((now - dataDate) / (1000 * 60));

        const tooOld = dataAge >= 15;

        if(tooOld){
            this.fetchData();
        } else {
           console.log(`Using data from localStorage that are ${dataAge} min old.`);
        }
        
        let options = [];
        this.state.originalData.forEach(item_type => {
            options.push({value: item_type.name, label: item_type.name});
        });
        this.setState({options, selectedOption: options[0]});
    }

    fetchData(){
        this.refs.searchForm.reset();
        this.setState({
            isLoading: false,
            data: [],
            originalData: [],
            message: ''
        });
        fetch(this.state.config.itemTypeUrl)
        .then(response => response.json())
        .then((parsedJSON) => {
            return parsedJSON.item_type.map(itemType => (
                {
                    id: `${itemType.id}`,
                    name: `${itemType.name}`,
                    items: []
                }) 
            )
        })
        .then((data) => {
            let options = [];
            data.forEach(item_type => {
                options.push({value: item_type.name, label: item_type.name});
            });
            this.setState({
                data,
                originalData: data,
                isLoading: false,
                options, 
                selectedOption: options[0]
            });
        })
        .then(() => {
            return fetch(this.state.config.url)
        })
        .then(response => response.json())
        .then((parsedJSON) => {
            return parsedJSON.item.map(item => (
                {
                    id: `${item.id}`,
                    name: `${item.name}`,
                    type: `${item.type}`,
                    hsncode: `${item.hsncode}`,
                    sgst_tax: `${item.sgst_tax}`,
                    cgst_tax: `${item.cgst_tax}`
                }) 
            )
        })
        .then((data) => {
            let d = this.state.originalData;
            d.forEach(itemType => {
                itemType.items = data.filter(function(item){
                    return item.type === itemType.name;
                });
            });
            this.setState({
                data : d,
                originalData: d,
                isLoading: false
            })
        })
        .catch(error => console.log(error))

    }

    componentWillUpdate(nextProps, nextState){
        localStorage.setItem(this.state.config.type, JSON.stringify(nextState.originalData));
        localStorage.setItem(this.state.config.type+'Date', Date.now());
        localStorage.setItem(this.state.options, JSON.stringify(nextState.options));
    }


    filterCriteria(e){
        e.preventDefault();
        const searchText = this.refs.inputText.value;
        const filteredList = this.state.originalData.filter(data => (data.name.toLowerCase().includes(searchText.toLowerCase()) || data.items.some(item => item.name.toLowerCase().includes(searchText.toLowerCase()))));
        
        this.setState({
            data: filteredList,
            message: filteredList.length > 0 ? '' : 'No matching '+this.state.config.type
        });
    }

    handleChange = (selectedOption) => {
        this.setState({selectedOption});
    }

    onEditClick(e, item){
        e.preventDefault();
        this.setState({item: item});
        let selectedOption = {value : item.type , label : item.type}
        this.setState({selectedOption });
        this.handleShow();
    }

    onDeleteClick(e, item){
        e.preventDefault();
        if (window.confirm('Are you sure you wish to delete this item?')){
            this.handleDeleteOfItem(item);
        }
    }

    handleDeleteOfItem = (item) => {
        let body = {}
        body = { "item" : [ item ] };
        fetch(this.state.config.url_delete_item, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: "cors",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                // "Content-Type": "application/x-www-form-urlencoded",
                // Accept: "application/json"
            },
            body: JSON.stringify(body), // body data type must match "Content-Type" header
        })
        .then(response => response.json())
        .then((data) => {
            if(data.success){
                toast.success("Deleted "+ this.state.config.type, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 5000
                });
                this.fetchData();
            } else {
                toast.error("Could not delete " + this.state.config.type + ". Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: false
                });
            }
        })
        .catch((error) => {
            console.log(error);
            toast.error("Could not delete " + this.state.config.type + ". Please try again.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: false
            });
        });
    }

    handleDeleteOfItemType = (item) => {
        if (window.confirm('Are you sure you wish to delete this Item Type?')){
            let body = {}
            body = { "item_type" : [ {
                                        name : item.name
                                    }
             ]};
            fetch(this.state.config.url_delete_item_type, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                // mode: "cors",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    // "Content-Type": "application/x-www-form-urlencoded",
                    // Accept: "application/json"
                },
                body: JSON.stringify(body), // body data type must match "Content-Type" header
            })
            .then(response => response.json())
            .then((data) => {
                if(data.success){
                    toast.success("Deleted Item Type", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000
                    });
                    this.fetchData();
                } else {
                    toast.error("Could not delete Item Type. Please try again.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: false
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error("Could not delete Item Type. Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: false
                });
            });
        }
    }

  
    render() {
        const {isLoading, data, message, config} = this.state;
        return (
            <div>
                <header>
                    <h1>{config.title} <button className="btn btn-sm btn-danger" onClick={(e) => {
                        this.fetchData();
                        }}>Refresh</button>
                        <button className="btn btn-sm btn-info" style={{marginLeft: "20px"}} onClick={this.handleShow}>New Item</button></h1>
                </header>
                <div>
                    <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                        <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "100%", marginBottom: "10px", padding: "5px", borderColor:"red"}} autoComplete="off"></input>
                    </form>
                </div>
                <div className={`content ${isLoading ? 'is-loading': ''}`} style={{minHeight: "50px", maxHeight: "500px", overflowX: "scroll"}}>
                    <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    <div className="panel-group">
                        {
                            !isLoading && data.length > 0 ? data.map(data => {
                                const {id, name, items} = data;
                                return <Collapsible key={id} title={name} user={data} onEditClick={this.handleShow} hasEditFeature={false} onDeleteClick={this.handleDeleteOfItemType} hasDeleteFeature={true}>
                                    <Table striped bordered condensed hover>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>HSN Code</th>
                                                <th>SGST</th>
                                                <th>CGST</th>
                                                <th style={{textAlign: "center"}}>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            items.map(item => {
                                                return <tr key={item.id}>
                                                            <td>{item.name}</td>
                                                            <td>{item.hsncode}</td>
                                                            <td>{item.sgst_tax}</td>
                                                            <td>{item.cgst_tax}</td>
                                                            <td style={{textAlign: "center"}}>
                                                                <Glyphicon title="Edit" glyph="pencil" onClick={(e) => this.onEditClick(e, item)}/>
                                                                <Glyphicon title="Delete" glyph="trash" onClick={(e) => this.onDeleteClick(e, item)} style={{marginLeft: "20px"}}/>
                                                            </td>
                                                </tr>
                                            })
                                        }
                                        </tbody>
                                    </Table>
                                </Collapsible>
                            }) : null
                        }
                    </div>
                    {
                        this.state.show &&
                            <Modal show={this.state.show} onHide={this.handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Add New Item</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <form>
                                        {/* <FormGroup>
                                            <ControlLabel>Name</ControlLabel>
                                            <FormControl.Static>{this.state.user.name}</FormControl.Static>
                                        </FormGroup> */}
                                        
                                        <Textbox
                                            tabIndex="1" //Optional.[String or Number].Default: -1.
                                            id={'name'} //Optional.[String].Default: "".  Input ID.
                                            name="name" //Optional.[String].Default: "". Input name.
                                            type="text" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                            value={this.state.item.name} //Optional.[String].Default: "".
                                            placeholder="Item Name" //Optional.[String].Default: "".
                                            validate={true}
                                            validationCallback = {res => this.setState({ hasError: res, validate: false })}
                                            onChange={(name, e) => {
                                                let u = this.state.item;
                                                u.name = name;
                                                this.setState({ item :  u});
                                            }} //Required.[Func].Default: () => {}. Will return the value.
                                            //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            validationOption={{
                                                name: 'Name', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                                check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                                //reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                //regMsg: 'Email id is not valid'
                                            }}
                                            //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            />
                                            <CreatableSelect
                                            tabIndex="2"
                                                value={this.state.selectedOption}
                                                onChange={this.handleChange}
                                                options={this.state.options}
                                                id={'type'}
                                                name='type'
                                                placeholder="Item Type"
                                                isClearable
                                            />

                                        <Textbox
                                            tabIndex="3" //Optional.[String or Number].Default: -1.
                                            id={'hsncode'} //Optional.[String].Default: "".  Input ID.
                                            name="hsncode" //Optional.[String].Default: "". Input name.
                                            type="number" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                            value={this.state.item.hsncode} //Optional.[String].Default: "".
                                            placeholder="HSN Code" //Optional.[String].Default: "".
                                            validate={true}
                                            validationCallback = {res => this.setState({ hasError: res, validate: false })}
                                            onChange={(hsncode, e) => {
                                                let u = this.state.item;
                                                u.hsncode = hsncode;
                                                this.setState({ item :  u});
                                            }} //Required.[Func].Default: () => {}. Will return the value.
                                            //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            validationOption={{
                                                name: 'HSN Code', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                                check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                                //reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                //regMsg: 'Email id is not valid'
                                            }}
                                            //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            />
                                        
                                        <Textbox
                                            tabIndex="4" //Optional.[String or Number].Default: -1.
                                            id={'sgst_tax'} //Optional.[String].Default: "".  Input ID.
                                            name="sgst_tax" //Optional.[String].Default: "". Input name.
                                            type="number" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                            value={this.state.item.sgst_tax} //Optional.[String].Default: "".
                                            placeholder="SGST Tax %" //Optional.[String].Default: "".
                                            validate={true}
                                            validationCallback = {res => this.setState({ hasError: res, validate: false })}
                                            onChange={(sgst_tax, e) => {
                                                let u = this.state.item;
                                                u.sgst_tax = sgst_tax;
                                                this.setState({ item :  u});
                                            }} //Required.[Func].Default: () => {}. Will return the value.
                                            //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            validationOption={{
                                                name: 'SGST Tax %', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                                check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                                reg: /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/i,
                                                regMsg: 'SGST Tax % is not valid'
                                            }}
                                            //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            />
                                        
                                        <Textbox
                                            tabIndex="5" //Optional.[String or Number].Default: -1.
                                            id={'cgst_tax'} //Optional.[String].Default: "".  Input ID.
                                            name="cgst_tax" //Optional.[String].Default: "". Input name.
                                            type="number" //Optional.[String].Default: "text". Input type [text, password, phone, number].
                                            value={this.state.item.cgst_tax} //Optional.[String].Default: "".
                                            placeholder="CGST Tax %" //Optional.[String].Default: "".
                                            validate={true}
                                            validationCallback = {res => this.setState({ hasError: res, validate: false })}
                                            onChange={(cgst_tax, e) => {
                                                let u = this.state.item;
                                                u.cgst_tax = cgst_tax;
                                                this.setState({ item :  u});
                                            }} //Required.[Func].Default: () => {}. Will return the value.
                                            //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            validationOption={{
                                                name: 'CGST Tax %', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                                                check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                                                reg: /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/i,
                                                regMsg: 'CGST Tax % is not valid'
                                            }}
                                            //onBlur={(e) => {console.log(e)}} //Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            />

                                    </form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit" onClick={this.handleSave}>Save</Button>
                                    <Button onClick={this.handleClose}>Cancel</Button>
                                </Modal.Footer>
                            </Modal>
                    }
                <div className="loader">
                    <div className="icon"></div>
                </div>
                </div>
            </div>
        );
    }
    
}
 
export default Item;


// WEBPACK FOOTER //
// ./src/js/Item.js